/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Project_Saved_ToastInputs */



/**
* | output |
* | --- |
* | "Project saved successfully" |
*
* @param {Explorer_Display_Project_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_project_saved_toast = /** @type {((inputs?: Explorer_Display_Project_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Project_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet enregistre avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto salvato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект успешно спасен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto salvo com sucesso")
	return /** @type {LocalizedString} */ ("Project saved successfully")
});